import script from "./CreateSubmissionView.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSubmissionView.vue?vue&type=script&setup=true&lang=js"

import "./CreateSubmissionView.vue?vue&type=style&index=0&id=f4a87c60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4a87c60"]])

export default __exports__